import { CommonModule } from '@angular/common';
import { 
  NgModule, 
  ModuleWithProviders, 
  Component, 
  Directive, 
  OnInit, 
  Input, 
  ViewEncapsulation, 
  ChangeDetectionStrategy 
} from '@angular/core';

/**
 * Endorsement body directive.
 */
@Component({
  selector: 'endorsement-body',
  templateUrl: 'endorsement-body.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EndorsementBody {}

/**
 * Endorsement author directive.
 */
@Component({
  selector: 'endorsement-author',
  templateUrl: 'endorsement-author.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EndorsementAuthor {}

@Component({
  selector: 'endorsement',
  templateUrl: './endorsement.html',
  styleUrls: ['./endorsement.scss']
})
export class Endorsement implements OnInit {

  constructor() {}

  ngOnInit() {}

}

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    Endorsement,
    EndorsementBody,
    EndorsementAuthor
  ],
  declarations: [
    Endorsement,
    EndorsementBody,
    EndorsementAuthor
  ],
})
export class EndorsementModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: EndorsementModule,
      providers: []
    };
  }
}



// WEBPACK FOOTER //
// /Users/jonshilton/Projects/nick-smith-app/src/app/modules/endorsement/endorsement.ts